import React from "react";
import {
  FormControlLabel,
  Typography,
  Button,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

function ViewResult() {
  return (
    <>
      <Typography component="subtitle2" align="center">
        멤버십 서비스의 증진을 위하여 고객의 개인정보를 제3자에게 제공할 수
        있습니다. 제3자에 대한 정보제공 관련사항(제공받는 자, 제공목적 및 제공할
        정보의 항목 및 이용기간)은 개인정보보호법에 따라 사전에 고지하며 고객이
        동의하지 않는 경우에는 제공하지 않습니다.
      </Typography>
      <hr />
    </>
  );
}
function ThirdParty(props) {
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };

  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.thirdParty}
              onChange={(e) => {
                props.onChangeThirdParty(e.target.checked);
              }}
              name="thirdParty"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [선택]개인정보 제3자 제공에 대한 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}
export default ThirdParty;
